import React, { useEffect, useState } from 'react';
import { Modal, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import welfareService from '../utils/welfareService';
import { snackbar } from '../utils/showMessage';


const getCategoryStyles = (title) => {
    return { backgroundColor: '#fff5f5', color: '#ff4d4f' };
};
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://appserver.tbzmc.com";


const WelfareCategories = () => {
    const [loading, setLoading] = useState(true);

    const [categories, setCategories] = useState([]);
    const [colClass, setColClass] = useState(() => (typeof window !== 'undefined' && window.innerWidth < 320 ? 'col-6' : 'col-3'));
    const [subModalOpen, setSubModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subCategories, setSubCategories] = useState([]);
    // مقداردهی شمارنده آیتم‌های هر زیرکتگوری
    const fetchSubItemsCount = async (category, subCats) => {
        if (!category || !Array.isArray(subCats)) return subCats;
        const updated = await Promise.all(subCats.map(async (sub) => {
            try {
                const count = await welfareService.getSubCategoryItemsCount(category._id, sub.id);
                // لاگ برای دیباگ
                return { ...sub, itemsCount: typeof count === 'number' ? count : 0 };
            } catch (e) {
                console.error('Error fetching count for subcategory', sub, e);
                return { ...sub, itemsCount: 0 };
            }
        }));
        // آیتم همه موارد
        let allCount = 0;
        try {
            const res = await welfareService.getSubCategoryItemsCount(category.id, undefined);
            allCount = typeof res === 'number' ? res : 0;
        } catch (e) {
            allCount = 0;
        }
        const allItem = {
            id: 'all',
            title: 'همه موارد',
            image: category.image,
            url: `welfare/${category.id}`,
            description: '',
            itemsCount: allCount,
            isAll: true,
        };
        return [...updated, allItem];

    };

    useEffect(() => {
        loadData();
    }, []);

    // const loadData = async () => {
    //     try {
    //         setLoading(true);
    //         const categoriesData = await welfareService.getCategories();
    //         setCategories(categoriesData);

    //     } catch (error) {
    //         console.error('Error loading welfare data:', error);
    //         snackbar('خطا در بارگذاری اطلاعات');
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const loadData = async () => {
        try {
            setLoading(true);
            const categoriesData = await welfareService.getHomeCategories();
            // فقط دسته‌بندی‌هایی که showOnHomePage=true دارند نمایش داده شوند
            // let filtered = (categoriesData || []).filter(cat => cat.showOnHomePage);

            // // زیرشاخه‌ها را نیز فیلتر کن
            // categoriesData.forEach(cat => {
            //     if (Array.isArray(cat.subCategories)) {
            //         filtered = [filtered, ...cat.subCategories.filter(sub => sub.showOnHomePage)];
            //     }
            // });
            setCategories(categoriesData?.filter(cat => cat.showOnHomePage));

        } catch (error) {
            console.error('Error loading welfare data:', error);
            snackbar('خطا در بارگذاری اطلاعات');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const check = () => setColClass(window.innerWidth < 330 ? 'col-6' : 'col-3');
        check();
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    return (
        <>
            <div className="row mb-4">
                <div className="col-12">
                    {(() => {
                        const rows = [];
                        let i = 0;
                        while (i < categories.length) {
                            const rowItems = categories.slice(i, i + 4);
                            let dynamicColClass = colClass;
                            if (rowItems.length === 1) dynamicColClass = 'col-12';
                            else if (rowItems.length === 2) dynamicColClass = 'col-6';
                            else if (rowItems.length === 3) dynamicColClass = 'col-4';
                            rows.push(
                                <div className="row gx-2 gy-3" key={`row-${i}`}>
                                    {rowItems.map((category) => {
                                        const styles = getCategoryStyles(category.title);
                                        const hasSub = Array.isArray(category.subCategories) && category.subCategories.length > 0;
                                        return (
                                            <div className={`${dynamicColClass} text-center`} key={category._id}>
                                                <div
                                                    className="text-decoration-none d-block"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={async () => {
                                                        if (hasSub) {
                                                            setSelectedCategory(category);
                                                            setSubModalOpen(true);
                                                            // شمارنده آیتم‌ها را برای هر زیرکتگوری دریافت کن
                                                            const subCatsWithCount = await fetchSubItemsCount(category, category.subCategories);
                                                            setSubCategories(subCatsWithCount);
                                                        } else {
                                                            window.location.href = `${category.url}`;
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className="avatar avatar-70 rounded-18 mb-2 mx-auto d-flex align-items-center justify-content-center shadow-sm"
                                                        style={{ ...styles, width: 70, height: 70 }}
                                                    >
                                                        <img
                                                            src={`${BASE_URL}/uploads/documents/${category.image}` || '/assets/img/default-service.png'}
                                                            alt={category.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12 }} />
                                                    </div>
                                                    <p className=" text-muted mb-0 fw-medium" style={{ fontSize: 10 }}>{category.title}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                            i += 4;
                        }
                        return rows;
                    })()}
                </div>
            </div>

            {/* Modal for subcategories */}
            <Modal open={subModalOpen} onClose={() => setSubModalOpen(false)}>
                <div style={{
                    position: "relative",
                    background: '#fff',
                    padding: 24,
                    borderRadius: 18,
                    maxWidth: '90vw',
                    width: '90vw',
                    height: '90vh',
                    margin: '5vh auto',
                    outline: 'none',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>


                    <h6 className="mb-3">{selectedCategory?.title}</h6>
                    <button
                        onClick={() => setSubModalOpen(false)}
                        style={{
                            position: 'absolute',
                            top: 12,
                            left: 12,
                            background: 'transparent',
                            border: 'none',
                            fontSize: 28,
                            cursor: 'pointer',
                            zIndex: 10,
                            color: '#888',
                        }}
                        aria-label="بستن"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="row w-100 mb-3">
                        <div className="col-12">
                            <div className="row gx-2 gy-3">


                                {subCategories.map(sub =>
                                    <Link

                                        to={`${sub.url}`}
                                        className="card mb-3 text-decoration-none"
                                    // style={{ borderRight: isPinned ? '4px solid #f59e0b' : 'none' }}
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                {sub.image && (
                                                    <div className="col-4 col-md-3">
                                                        <img
                                                            src={`${BASE_URL}/uploads/documents/${sub.image}` || '/assets/img/default-service.png'}
                                                            alt={sub.title}
                                                            className="w-100 rounded-15"
                                                            style={{ height: '100px', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                )}
                                                <div className={sub.image ? 'col-8 col-md-9' : 'col-12'}>


                                                    <h6 className="mb-2">{sub.title}</h6>
                                                    {sub.description && (
                                                        <p className="text-muted mb-2 text-justify" style={{ fontSize: '0.9rem' }}>
                                                            {sub.description.length > 100
                                                                ? sub.description.substring(0, 100) + '...'
                                                                : sub.description}
                                                        </p>
                                                    )}
                                                    <div className="d-flex justify-content-end align-items-bottom">

                                                        <small className="text-muted">
                                                            {typeof sub.itemsCount === 'number' ? sub.itemsCount : 0} مورد
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                )}


                                {/* <Link

                                        to={`/welfare/${selectedCategory?._id}?sub=${sub.id}`}
                                        className="card mb-3 text-decoration-none"
                                     >
                                        <div className="card-body">
                                            <div className="row">
                                                {sub.image && (
                                                    <div className="col-4 col-md-3">
                                                        <img
                                                            src={`${BASE_URL}/uploads/documents/${sub.image}` || '/assets/img/default-service.png'}
                                                            alt={sub.title}
                                                            className="w-100 rounded-15"
                                                            style={{ height: '100px', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                )}
                                                <div className={sub.image ? 'col-8 col-md-9' : 'col-12'}>


                                                    <h6 className="mb-2">{sub.title}</h6>
                                                    {sub.description && (
                                                        <p className="text-muted mb-2 text-justify" style={{ fontSize: '0.9rem' }}>
                                                            {sub.description.length > 100
                                                                ? sub.description.substring(0, 100) + '...'
                                                                : sub.description}
                                                        </p>
                                                    )}
                                                    <div className="d-flex justify-content-end align-items-bottom">
                                
                                                        <small className="text-muted">
                                                             {sub.itemsCount || 0} مورد
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};



export default WelfareCategories;
